import React from 'react'
import { useFetchGifs } from '../hooks/useFetchGifs';
import { deleteLocalStorage } from '../helpers/deleteLocalStorage';
import {Gif, Spinner} from "./index";


export const ContainerGifs = ({category, setCheckDeleted, checkDeleted}) => {
	const {images, loading} = useFetchGifs(category);

	const handleClick = (element) => {
		deleteLocalStorage(element);
		if (checkDeleted) setCheckDeleted(false);
		else setCheckDeleted(true);
    }

	return (
		<section className = "container-gifs">
			<div className="container-info">
				<h1>{category}</h1>
				<button onClick = {() => {handleClick(category)}}>Delete from the list</button>
			</div>
			{
				loading && <Spinner />
			}
			<div className = "card-grid">
				{
					images.map(image => (
						<Gif key = {image.id} {...image} />
					))
				}
			</div>
			
		</section>
	)
}
